// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeId } from './BrewcontrolNode';
import { brewcontrolWorkspaceId } from './BrewcontrolWorkspace';
import { brewcontrolConfigKindEnum } from './BrewcontrolConfigKindEnum';
import { brewcontrolWiringLineageId } from './BrewcontrolWiringLineage';
import { z } from 'zod';
export const brewcontrolConfigVersionId = (z.string());
export const brewcontrolConfigVersion = z.object({
    id: brewcontrolConfigVersionId,
    node_id: brewcontrolNodeId.nullable(),
    workspace_id: brewcontrolWorkspaceId.nullable(),
    kind: brewcontrolConfigKindEnum,
    version: z.number(),
    content: z.string(),
    content_hash: z.string(),
    restored_from_id: brewcontrolConfigVersionId.nullable(),
    created_by: z.string(),
    created_at: z.date(),
    lineage_id: brewcontrolWiringLineageId.nullable(),
});
export const brewcontrolConfigVersionInitializer = z.object({
    id: brewcontrolConfigVersionId.optional(),
    node_id: brewcontrolNodeId.optional().nullable(),
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    kind: brewcontrolConfigKindEnum,
    version: z.number(),
    content: z.string(),
    content_hash: z.string(),
    restored_from_id: brewcontrolConfigVersionId.optional().nullable(),
    created_by: z.string().optional(),
    created_at: z.date().optional(),
    lineage_id: brewcontrolWiringLineageId.optional().nullable(),
});
export const brewcontrolConfigVersionMutator = z.object({
    id: brewcontrolConfigVersionId.optional(),
    node_id: brewcontrolNodeId.optional().nullable(),
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    kind: brewcontrolConfigKindEnum.optional(),
    version: z.number().optional(),
    content: z.string().optional(),
    content_hash: z.string().optional(),
    restored_from_id: brewcontrolConfigVersionId.optional().nullable(),
    created_by: z.string().optional(),
    created_at: z.date().optional(),
    lineage_id: brewcontrolWiringLineageId.optional().nullable(),
});
//# sourceMappingURL=BrewcontrolConfigVersion.js.map